import styled from 'styled-components'

import AddonInfoButton from '~/components/addon-info-button'
import CheckboxInput from '~/components/checkbox-input'
import SpotLogo from '~/graphics/spot.png'
import { device, font } from '~/styles/utils'

export const Wrapper = styled.div`
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  @media ${device('notMobile')} {
    margin-bottom: 10px;
  }
`

export const BlueCheckboxInput = styled(CheckboxInput)``

export const ProductLine = styled.div`
  ${font('base')};
  display: flex;
  justify-content: space-between;
  flex: 100% 1 1;
`

export const ProductPrice = styled.div<{
  $insuranceAwaitingApplication?: boolean
}>`
  font: ${({ $insuranceAwaitingApplication }) =>
    $insuranceAwaitingApplication ? font('base') : font('demi')};
  color: ${({ $insuranceAwaitingApplication }) =>
    $insuranceAwaitingApplication && '#70706d'};
  margin: auto 0;
  white-space: nowrap;
  width: 90px;
  text-align: right;
`

export const StyledAddonInfoButton = styled(AddonInfoButton)`
  margin-top: 3px;
  justify-self: start;
  align-self: start;
  && {
    padding: 0;
    padding-left: 10px;
  }
`

export const CartPassInsurance = styled.div`
  ${font('base')};
  display: flex;

  text-transform: none;
`

export const AddonHeading = styled.span`
  ${font('demi')};
  &::after {
    content: ' ';
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.sm.max}) {
    &::after {
      content: ': ';
    }
  }
`

export const AddonBody = styled.span`
  display: none;

  @media ${device('notMobile')} {
    display: unset;
  }
`

export const Logo = styled.img.attrs(() => ({
  src: SpotLogo,
  alt: 'Spot Insurance',
}))`
  display: block;
  width: 75px;
  height: 30px;
  flex-shrink: 0;

  @media ${device('notMobile')} {
    margin-top: 10px;
  }
`
